import React, {useState, useEffect, isValidElement} from 'react'
import {
	Button,
	Card,
	Col,
	Form,
	Input,
	Row,
	Select,
	Typography,
	Upload,
	Radio
} from "antd";

import data from '../../data/coatingData'

const CoatingSelector = (props) => {
    const {coatingType}  = data

    const handleCoatingChange = (field, val) => {
		if(field === 'coatings'){
			props.setCoating({ ...props.coating, coatings: val });
		}
    }
  return (
    <>
        <Card>
         		<Form.Item
					style={{ marginBottom: "15px" }}
					name='coating_type'
					label='Coating Type'
					rules={[
						{
							required: true,
							message: "Please select coating type!",
						},
					]}>
					<Select
						name='coating_type'
						mode="multiple"
						loading={!coatingType}
						showSearch
						placeholder='Coating Type'
						optionFilterProp='children'
						filterOption={(input, option) =>
							option.children.includes(input)
						}
						filterSort={(optionA, optionB) =>
							optionA.children
								.toLowerCase()
								.localeCompare(optionB.children.toLowerCase())
						}
						onChange={(val) => handleCoatingChange('coatings', val) }
						>
						{coatingType &&
							coatingType.map((coating, i) => (
								<Select.Option key={i+1} value={coating}>
									{coating}
								</Select.Option>
							))}
					</Select>
				</Form.Item>
             
        </Card>
    </>
  )
}

export default CoatingSelector
